<script setup lang="ts">
	import { ref } from 'vue';
	import { onLaunch, onShow, onHide } from "@dcloudio/uni-app";
	import { initPermission } from '@/utils/permission'


	onLaunch(() => {
	});
	onShow(() => {
		initPermission();
	});
	onHide(() => {

	});


	
</script>

<style lang="scss">
	page {
		background-color: #F6F6FD;
		padding: 0 26rpx 0 26rpx;
	}
</style>